export default __webpack_public_path__ + "static/media/CarDetailing.fda5d52e.jpg";